<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_subtitle_recommendations') }}</span>
      </template>
    </navbar>
    <div class="transparent headers-initial">
      <f7-block-title class="block-title-result">
        <span class="color-title-OpenAir">RECOMENDACIONES / ACTUACIÓN</span>
      </f7-block-title>
    </div>
    <div class="content-form">
      <div class="form-recommendations">
        <DxForm
          label-mode="static"
          label-location="top"
          col-count="auto"
          :col-count-by-screen="colCountByScreen"
          :screen-by-width="screenByWidth"
        >
          <DxGroupItem
            css-class="content-devx"
            :caption="$t('LeftPanel_subtitle_Irrigation')"
            :col-span="4"
            :col-count="4"
          >
            <DxSimpleItem
              :col-span="4"
              name="typeIrrigation"
              :data-field="
                $t('registerProject.registerProjectOpenAir.register_project_typeIrrigation')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: itemsTypesIrrigation,
                value: resultProject && resultProject.irrigation
                  ? resultProject.irrigation.irrigation_open_air : null,
                searchEnabled: true,
                onValueChanged: onChangeTypeIrrigation,
                placeholder: '',
                readOnly: true
              }"
            />
            <DxSimpleItem
              data-field=""
              editor-type="dxCheckBox"
              css-class="checkRecommendation"
              :editor-options="{
                value: checkIrrigationRM,
                onValueChanged: onChangeCheckRecommendedContribution,
              }"
            />
            <DxSimpleItem
              :col-span="3"
              name="RecommendedContribution"
              data-field="Aportación recomendada (mm)"
              editor-type="dxNumberBox"
              :editor-options="{
                value: RecommendedContribution,
                onValueChanged: onChangeRecommendedContribution,
                readOnly: true
              }"
            />
            <DxSimpleItem
              data-field=""
              editor-type="dxCheckBox"
              css-class="checkRecommendation"
              :editor-options="{
                value: checkIrrigationCM,
                onValueChanged: onChangeCheckContributionMade,
              }"
            />
            <DxSimpleItem
              :col-span="3"
              name="ContributionMade"
              data-field="Aportación realizada (mm)"
              editor-type="dxNumberBox"
              :editor-options="{
                value: ContributionMade,
                onValueChanged: onChangeContributionMade,
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
          <DxGroupItem
            css-class="content-devx"
            caption="Aportación N"

            :col-span="4"
            :col-count="4"
          >
            <DxSimpleItem
              :col-span="4"
              data-field="Aportación N necesaria (kg N/ha)"
              editor-type="dxNumberBox"
              :editor-options="{
                value: fertilizationN,
                onValueChanged: onChangeFertilizationN,
                readOnly: true
              }"
            />
            <DxSimpleItem
              :key="`fertilizers_${keyFertilizers}`"
              :col-span="4"
              name=""
              data-field="Tipo de fertilizante"
              editor-type="dxSelectBox"
              :editor-options="{
                items: fullListFertilizers,
                value: fertilizerType,
                displayExpr: 'nameMedio',
                valueExpr: 'id',
                searchEnabled: true,
                onValueChanged: onChangeFertilizerType,
                placeholder: '',
              }"
            />
            <DxSimpleItem
              data-field=""
              editor-type="dxCheckBox"
              css-class="checkRecommendation"
              :editor-options="{
                value: checkNUptakeRC,
                onValueChanged: onChangeCheckNUptakeRC,
              }"
            />
            <DxSimpleItem
              :col-span="3"
              name="RecommendedContribution"
              data-field="Aportación recomendada (kg fertilizante N/ha)"
              editor-type="dxNumberBox"
              :editor-options="{
                value: NUptakeRC,
                onValueChanged: onChangeNUptakeRC,
                readOnly: true
              }"
            />
            <DxSimpleItem
              data-field=""
              editor-type="dxCheckBox"
              css-class="checkRecommendation"
              :editor-options="{
                value: checkNUptakeCM,
                onValueChanged: onChangeCheckNUptakeCM,
              }"
            />
            <DxSimpleItem
              :col-span="3"
              name="ContributionMade"
              data-field="Aportación realizada (kg fertilizante N/ha)"
              editor-type="dxNumberBox"
              :editor-options="{
                value: NUptakeCM,
                onValueChanged: onChangeNUptakeCM,
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
        </DxForm>
      </div>
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-button
        class="dx-btn-success open-air"
        raised
        type="success"
        styling-mode="contained"
        name="ButtonSave"
        @click="save"
      >
        {{ $t("execute") }}
      </f7-button>
    </f7-block-footer>
    <DxPopUpFertilizers />
  </f7-page>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { DxForm, DxGroupItem, DxSimpleItem } from 'devextreme-vue/form';
import moment from 'moment';
import navbar from '../../../components/navbar/NavBar.vue';
import DxPopUpFertilizers from '../../../components/registerProject/registerProjectGreenhouse/PopUpFertilizers/index.vue';
import EventBus from '../../../js/event-bus';

export default {
  name: 'RecommendationsResult',
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    navbar,
    DxPopUpFertilizers,
  },
  data() {
    return {
      temperature: [],
      humidity: [],
      solarRadiation: [],
      eto: [],
      loaded: false,
      itemsTypesIrrigation: ['SUPERFICIE', 'LOCALIZADO'],
      readOnly: false,
      RecommendedContribution: null,
      ContributionMade: null,
      checkIrrigationRM: null,
      checkIrrigationCM: null,
      NUptakeRC: null,
      NUptakeCM: null,
      checkNUptakeRC: null,
      checkNUptakeCM: null,
      fertilizationN: null,
      fertilizerType: null,
      keyFertilizers: 0,
      fullListFertilizers: [],
    };
  },
  computed: {
    ...mapState('authentication', ['selection']),
    ...mapState('Result', [
      'resultProject',
    ]),
    ...mapState('Database', [
      'listFertilizers',
    ]),
    colCountByScreen() {
      return {
        sm: 4,
        md: 4,
      };
    },
  },
  beforeMount() {
    this.keyName = this.$f7.views.main.router.currentRoute.path;
    EventBus.$on('selected-fertilizer', (item) => {
      if (item) {
        this.fullListFertilizers.push(
          {
            ...item,
            nameMedio: `${item.name} (${item.n}%)`,
          },
        );
        this.fertilizerType = item.id;
        this.keyFertilizers += 1;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('selected-fertilizer');
  },
  async mounted() {
    this.$f7.preloader.show();
    try {
      if (this.resultProject) {
        // let index = 0;
        // const cultiveDateInit = moment(this.resultProject.cultive.date_init).toDate();
        // const now = new Date(Date.now());
        // // To calculate the time difference of two dates
        // const differenceInTime = now.getTime() - cultiveDateInit.getTime();
        // // To calculate the no. of days between two dates
        // const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        // index = Math.trunc(differenceInDays);
        if (
          this.resultProject.result
          && this.resultProject.result.irrigation_recomendation
          && this.resultProject.result.irrigation_recomendation.length
          // && index < this.resultProject.result.irrigation_recomendation.length
          // && index >= 0
        ) {
          this.RecommendedContribution = this.resultProject.result
            .irrigation_recomendation.reduce((partialSum, a) => partialSum + a, 0);
          this.RecommendedContribution = this.RecommendedContribution.toFixed(1);
        }
        if (
          this.resultProject.result
          && this.resultProject.result.n_recomendation
          && this.resultProject.result.n_recomendation.length
          // && index < this.resultProject.result.n_recomendation.length
          // && index >= 0
        ) {
          this.fertilizationN = this.resultProject.result
            .n_recomendation.reduce((partialSum, a) => partialSum + a, 0);
          this.fertilizationN = this.fertilizationN.toFixed(1);
        }
        this.ContributionMade = this.resultProject.user_irrigation;
        this.NUptakeCM = this.resultProject.user_n_uptake;
        this.checkIrrigationRM = this.resultProject.irrigation_calculate_type === 'RECOMENDATION';
        this.checkIrrigationCM = this.resultProject.irrigation_calculate_type !== 'RECOMENDATION';
        this.checkNUptakeRC = this.resultProject.n_calculate_type === 'RECOMENDATION';
        this.checkNUptakeCM = this.resultProject.n_calculate_type !== 'RECOMENDATION';
      }
      this.$f7.preloader.show();
      await this.fetchListFertilizers();
      this.fullListFertilizers = [{ nameMedio: 'Añadir', id: 'Añadir' }, ...this.listFertilizers];
    } catch (e) {
      console.log(e);
      const message = this.$helpers.getFilteredErrorMessage(e);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    screenByWidth(width) {
      return width < 720 ? 'sm' : 'md';
    },
    goToResultOpenAirPage() {
      this.$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true });
    },
    onChangeTypeIrrigation(e) {
      console.log(e);
    },
    onChangeRecommendedContribution(e) {
      this.RecommendedContribution = e.value;
    },
    onChangeContributionMade(e) {
      this.ContributionMade = e.value;
    },
    onChangeCheckRecommendedContribution(e) {
      this.checkIrrigationRM = e.value;
      this.checkIrrigationCM = !e.value;
    },
    onChangeCheckContributionMade(e) {
      this.checkIrrigationRM = !e.value;
      this.checkIrrigationCM = e.value;
    },
    onChangeNUptakeRC(e) {
      this.NUptakeRC = e.value;
    },
    onChangeNUptakeCM(e) {
      this.NUptakeCM = e.value;
    },
    onChangeCheckNUptakeRC(e) {
      this.checkNUptakeRC = e.value;
      this.checkNUptakeCM = !e.value;
    },
    onChangeCheckNUptakeCM(e) {
      this.checkNUptakeRC = !e.value;
      this.checkNUptakeCM = e.value;
    },
    onChangeFertilizationN(e) {
      this.fertilizationN = e.value;
    },
    onChangeFertilizerType(e) {
      if (e.value === 'Añadir') {
        this.setEnabledPopUpFertilizers(true);
        this.fertilizerType = null;
        this.NUptakeRC = null;
        this.keyFertilizers += 1;
      } else {
        this.fertilizerType = e.value;
        const findFertilizer = this.listFertilizers.find((item) => item.id === e.value);
        if (findFertilizer) {
          this.NUptakeRC = (this.fertilizationN / findFertilizer.n) * 100;
          this.NUptakeRC = this.NUptakeRC.toFixed(1);
        }
      }
    },
    async save() {
      try {
        this.$f7.preloader.show();
        const data = {
          user_irrigation: this.checkIrrigationCM
            ? this.ContributionMade : 0,
          user_n_uptake: this.checkNUptakeCM ? this.NUptakeCM : 0,
          irrigation_calculate_type: this.checkIrrigationCM ? 'USER_VALUES' : 'RECOMENDATION',
          n_calculate_type: this.checkNUptakeCM ? 'USER_VALUES' : 'RECOMENDATION',
        };
        const obj = { data, id: this.resultProject.id };
        await this.recalculateProject(obj);
        this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
      } catch (error) {
        this.$f7.dialog.alert('¡Upss ha ocurrido un error! Por favor verifique sus datos.');
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('Database', ['fetchListFertilizers']),
    ...mapActions('ProjectOpenAir', ['recalculateProject', 'setEnabledPopUpFertilizers']),
  },
};
</script>

<style lang="scss" scoped>
.block-title-result {
  border-bottom: 1px solid #51A411;
}
.content-form {
  width: 100%;
  display: flex;
  justify-content: center;
}
.form-recommendations {
  max-width: 720px;
}
</style>
